<div
  class="bg-m0 flex h-full w-full min-w-[2px] select-none flex-col rounded shadow"
>
  <div
    class="text-r1 mb-6 ml-7 mr-6 mt-6 flex h-11 flex-shrink-0 flex-row items-center space-x-3 text-2xl font-semibold"
  >
    <m-exclamation-icon></m-exclamation-icon>
    <div>Errors</div>
    <div class="flex flex-1"></div>
    <div
      *ngIf="isProduction === false"
      tp="FileEditor role is required to validate files"
      [tpIsEnabled]="isEditor === false"
    >
      <button
        type="button"
        data-cy="errorsValidateButton"
        class="h-11 flex-shrink-0 select-none rounded border px-5 py-2 text-base font-medium focus:outline-none"
        [ngClass]="{
          'border-s400 text-s500 hover:bg-gray-50':
            isEditor === true && needSave === false,
          'border-s300 text-s400 cursor-default':
            isEditor === false || needSave === true
        }"
        (click)="validateClick.emit()"
        [disabled]="isEditor === false || needSave === true"
        >Validate Files</button
      >
    </div>
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div class="flex w-full flex-grow flex-col overflow-y-auto pl-5">
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <div class="mt-2"></div>
      <tree-root
        class="h-2 w-full"
        #itemsTree
        [nodes]="nodes"
        [options]="treeOptions"
        (initialized)="treeOnInitialized()"
        (updateData)="treeOnUpdateData()"
      >
        <ng-template #treeNodeTemplate let-node="node">
          <div class="flex w-full flex-row pr-5">
            <div
              data-cy="blockmlErrorsTreeItem"
              class="flex min-h-[44px] w-full select-none flex-row rounded pl-5"
              [ngClass]="{
                'cursor-pointer': node.data.isError === false,
                'text-m600 font-semibold':
                  node.data.isError === false &&
                  !!fileNodeId &&
                  node.data.id === fileNodeId,
                'hover:bg-m50': node.data.isError === false
              }"
              (click)="nodeOnClick(node)"
            >
              <div
                class="flex w-full flex-1 flex-row items-center"
                [ngClass]="{
                  'ml-2': node.data.isError
                }"
              >
                <div class="flex min-w-[2px] flex-1 items-center">
                  <div class="flex flex-shrink-0 flex-row space-x-1">
                    <div class="h-6 w-6" *ngIf="!node.hasChildren"></div>
                    <m-chevron-right-icon
                      *ngIf="!node.isExpanded && node.hasChildren"
                    ></m-chevron-right-icon>
                    <m-chevron-down-icon
                      *ngIf="node.isExpanded && node.hasChildren"
                    ></m-chevron-down-icon>
                  </div>

                  <div
                    class="ml-2 flex min-h-[44px] min-w-[2px] items-center truncate text-base"
                    *ngIf="node.data.isError === false"
                  >
                    {{ node?.data.name }}
                  </div>

                  <div
                    *ngIf="node.data.isError === true"
                    class="mb-3 mt-3 flex min-w-[2px] flex-1 flex-col"
                  >
                    <div class="text-r1 flex w-full select-text text-base">{{
                      node.data.title
                    }}</div>

                    <div
                      class="text-s500 mb-1 mt-2 select-text break-words text-base"
                      >{{ node.data.message | capitalize }}</div
                    >

                    <div
                      *ngFor="let line of node.data.lines"
                      class="hover:bg-m50 flex pl-5 text-base hover:cursor-pointer"
                      [ngClass]="{
                        'py-2': line.fileId !== ''
                      }"
                      (click)="goToFileLine(line)"
                    >
                      <div
                        class="flex w-full flex-row"
                        *ngIf="line.fileId !== ''"
                      >
                        <div
                          class="flex font-semibold"
                          *ngIf="line.fileId === node.parent?.data.id"
                          >line:
                          {{
                            line.lineNumber === 0 ? '-' : line.lineNumber
                          }}</div
                        >
                        <div
                          class="flex font-semibold"
                          *ngIf="line.fileId !== node.parent?.data.id"
                          >line:
                          {{ line.lineNumber === 0 ? '-' : line.lineNumber }}

                          <span class="ml-5">
                            {{ line.fileName }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </tree-root>
    </ng-scrollbar>
  </div>
</div>

<div *ngIf="struct$ | async"></div>
<div *ngIf="file$ | async"></div>
